// @vendors
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';

// @assets
import { theme } from '../../assets/theme';
import { makeStyles } from '@mui/styles';

// @components
import Footer from '../Footer';
import Header from '../Header';
import { ROUTENAME } from '../../navigation/RouteName';

const ProtectedRoute = (props) => {
  let id = props.computedMatch.params.id;
  const Component = props.component;
  const authToken = useSelector((loadedState) => loadedState.user.accessToken);
  const classes = useStyles();

  useEffect(() => {
    document.title = `RockerBox - ${props.title}`;
  });

  return authToken ? (
    <>
      <Header title={props.name} />
      <main className={classes.content}>
        <Component id={id} />
      </main>
      <Footer title={props.name} />
    </>
  ) : (
    <Redirect to={{ pathname: ROUTENAME.login }} />
  );
};

export default ProtectedRoute;

const useStyles = makeStyles((_) => ({
  content: {
    padding: '15px 0 30px 0',
    width: '100%',
    height: '100%',
    background: theme.background.default,
    [theme.breakpoints.down('sm')]: {
      padding: '15px 0 30px 0',
    },
  },
}));
